import { render, staticRenderFns } from "./editCustomGoods.vue?vue&type=template&id=ee79b6b0&scoped=true&"
import script from "./editCustomGoods.vue?vue&type=script&lang=js&"
export * from "./editCustomGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee79b6b0",
  null
  
)

export default component.exports